<template>
  <div class="payment-receipt-create-bottom-grid">
    <article class="invoice-create-card invoice-create-summary-card payment-receipt-create-summary-card">
      <div class="invoice-create-summary-total payment-receipt-create-summary-total">
        <span>{{ text.create.ui.bottomSection.totalTitle }}</span>
        <div class="invoice-create-summary-value">
          <strong>{{ formatMoney(total) }}</strong>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import { useDomainText } from '@/composables/text/useDomainText';
import { formatCurrency } from '@/utils/numberFormat';

const { catalog: expenseReceiptsText } = useDomainText('expenseReceipts');

export default {
  name: 'ExpenseReceiptCreateBottomSection',
  props: {
    total: {
      type: Number,
      default: 0,
    },
    currency: {
      type: String,
      default: 'MXN',
    },
  },
  data() {
    return {
      text: expenseReceiptsText,
    };
  },
  methods: {
    formatMoney(amount) {
      return formatCurrency(amount, { currency: this.currency });
    },
  },
};
</script>

<style scoped>
.payment-receipt-create-bottom-grid {
  display: flex;
  justify-content: flex-end;
}

.payment-receipt-create-summary-card {
  width: min(420px, 100%);
}

.payment-receipt-create-summary-total {
  margin-top: 0;
  padding-top: 0;
  border-top: 0;
}
</style>
